import { Component, OnInit } from '@angular/core';
import { NewsService } from '../../../services/newsService';

import { uploadService } from '../../../services/uploadService';
import { Upload } from '../../../entities/upload';

@Component({
  selector: 'app-slide-brand',
  templateUrl: './slide-brand.component.html',
  styleUrls: ['./slide-brand.component.css']
})
export class SlideBrandComponent implements OnInit {

  getAdvertisementData;
  urlPhotoAdver;

  // // variable Upload Slide Brand 
  selectedFilesAdver: FileList;
  currentUploadAdver: Upload;
  constructor(private nSv: NewsService, public upSvc: uploadService,) { }

  ngOnInit() {
    let getAdvertisement = this.nSv.getAdvertise();
    getAdvertisement.subscribe((snapshot) => {
      this.getAdvertisementData = snapshot;
    })
  }
  detectAdvertisement(event) {
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.urlPhotoAdver = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    this.selectedFilesAdver = event.target.files;
  }
  addAdvertisement() {
      let dataAd = {
        header: '',
        contentHeader: '',
        content: '',
        pathimg: ''
      }
      let file = this.selectedFilesAdver.item(0)
      this.currentUploadAdver = new Upload(file);
      this.upSvc.addAdvertise(dataAd,this.currentUploadAdver)
  }
  removeAdvertise(id) {
    this.nSv.removeAdverise(id)
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/slide-brand/slide-brand.component.ts